import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Honymoon(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M12 1C8.58 1 7.237 3.496 7.014 4.836a1 1 0 00.279.871l.641.641C4.904 7.746 3 11.108 3 14.235 3 19.104 7.058 23 12 23s9-3.896 9-8.765c0-3.446-2.039-6.41-4.978-7.842l.685-.686a1 1 0 00.28-.871C16.762 3.496 15.42 1 12 1zm2.501 6.913l-1.794 1.794a1 1 0 01-1.414 0L9.469 7.883c-.048.026-.1.048-.153.066C6.778 8.795 5 11.599 5 14.235 5 17.943 8.106 21 12 21s7-3.057 7-6.765c0-2.848-1.827-5.307-4.445-6.3a.999.999 0 01-.054-.022zM12 7.586L9.123 4.709C9.427 3.983 10.238 3 12 3c1.408 0 2.209.628 2.629 1.25H12.75a.75.75 0 000 1.5h1.086L12 7.586z",
    clipRule: "evenodd"
  }));
}

export default Honymoon;